import { ORDENES_SALIDA } from '../actions/types';

const marker = String.fromCharCode(92,117,48,51,48,48,45,92,117,48,51,54,102);
const normalizeRegex = new RegExp('[' + marker + ']', 'g');

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    return (val + '')
        .toLowerCase()
        .normalize('NFD')
        .replace(normalizeRegex, '')
        .trim();
};

const initialState = {
    listado: [],
    filtrado: [],
    error: null,

    detalle: null,
    loadingDetalle: false
};

export default function ordenesSalidaReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case ORDENES_SALIDA.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case ORDENES_SALIDA.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((o) => {
                const folio = normalize(o?.folio);
                const cotizacion = normalize(o?.cotizacion?.folio);

                return folio.includes(texto) || cotizacion.includes(texto);
            });

            return { ...state, filtrado };
        }

        case ORDENES_SALIDA.LIMPIAR:
            return { ...initialState };

        case ORDENES_SALIDA.DETALLE_CARGANDO:
            return {
                ...state,
                detalle: null,
                loadingDetalle: true
            };

        case ORDENES_SALIDA.DETALLE:
            return {
                ...state,
                detalle: payload || null,
                loadingDetalle: false
            };

        case ORDENES_SALIDA.LIMPIAR_DETALLE:
            return {
                ...state,
                detalle: null,
                loadingDetalle: false
            };

        case ORDENES_SALIDA.ERROR:
            return { ...state, error: payload, loadingDetalle: false };

        default:
            return state;
    }
}
